import { reset, setClientInfo } from '../../../utils/vuex'
import getDefaultState from './defaultState'
const defaultState = getDefaultState()

export default {
  set: setClientInfo(),
  reset: reset(defaultState)
}
